import Footer from '@/components/navigation/Footer';
import Header from '@/components/navigation/Header';
import Sidebar from '@/components/navigation/Sidebar';
import { motion } from 'framer-motion';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Outlet, useLocation } from 'react-router-dom';

const MainLayout = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const { t } = useTranslation();

  // Close sidebar on route change on mobile
  useEffect(() => {
    setIsSidebarOpen(false);
  }, [location.pathname]);

  // Set page title based on current route
  useEffect(() => {
    const getTitle = () => {
      const path = location.pathname.split('/')[1];
      
      if (!path) return t('app.name');
      
      const routes: Record<string, string> = {
        dashboard: t("nav.dashboard"),
        courses: t("nav.courses"),
        analytics: t("nav.analytics"),
        employees: t("nav.employees"),
        leaderboard: t("nav.leaderboard"),
        policies: t("nav.policies"),
        faq: t("nav.faq"),
        profile: t("nav.profile"),
        settings: t("nav.settings"),
      };
      
      return `${routes[path] || path} | ${t('app.name')}`;
    };
    
    document.title = getTitle();
  }, [location.pathname, t]);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  return (
    <div className="flex h-screen bg-gray-50 dark:bg-gray-900">
      {/* Sidebar */}
      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      
      {/* Main Content */}
      <div className="flex flex-1 flex-col">
        <Header toggleSidebar={toggleSidebar} />
        
        <main className="flex-1 overflow-y-auto px-4 py-8 md:px-6 lg:px-8">
          <motion.div
            key={location.pathname}
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.2 }}
          >
            <Outlet />
          </motion.div>
        </main>
        
        <Footer />
      </div>
    </div>
  );
};

export default MainLayout;
